import React, { useRef } from 'react'
import { TextField, Button } from '@shopify/polaris'
import axios from 'axios'

const FileInputComponent = (props) => {
  const inputFileRef = useRef()
  /**
   * Trigger hidden file input to open upload modal
   * @param e
   */
  const handleButtonClick = (e) => {
    inputFileRef.current.click()
  }

  async function checkFileUrl(endpoint, bodyParams, maxRetries, currentRetry = 0) {
    try {
      const response = await axios.post(endpoint, bodyParams); // Send post request with params
      if (response.data && response.data.url) {
        // return url if we have
        return response.data.url;
      } else if (currentRetry < maxRetries) {
        // Retry if we have empty object
        await new Promise(resolve => setTimeout(resolve, 5000)); // wait 5 seconds before retrying
        return checkFileUrl(endpoint, bodyParams, maxRetries, currentRetry + 1); // Retry
      } else {
        // Maximum retry => stop retrying
        throw new Error('Maximum retries reached, file is not ready.');
      }
    } catch (error) {
      // Error handler
      if (currentRetry >= maxRetries) {
        console.error('Maximum retries reached, unable to get the file URL.');
      } else {
        console.error('An error occurred:', error);
      }
      throw error; // Throw error to stop the function
    }
  }

  /**
   * Sending request to upload file
   * @param event
   */
  const handleFileChange = async (event) => {
    if (props.onFileStartUploading) props.onFileStartUploading()
    const file = event.target.files[0]
    const req = await axios.post('/staged-uploads', {
      name: file.name,
      type: file.type,
      size: file.size
    })

    const { url, parameters, resourceUrl } = req.data

    const formData = new FormData()
    parameters.forEach(({ name: paramName, value }) =>
      formData.append(paramName, value)
    )
    formData.append("file", file)
    await axios.post(url, formData)
    const fileCreateReq = await axios.post('/file-create', {
      resourceUrl
    })
    const { data: { id } } = fileCreateReq
    // send request to the endpoint "get-file" to get the file url. Keep retrying until the file is ready every 2 seconds
    const endpoint = '/get-file';
    const bodyParams = { id };
    const maxRetries = 10;

    try {
      const fileUrl = await checkFileUrl(endpoint, bodyParams, maxRetries);
      handleInputChange(fileUrl)
    } catch (error) {
      // Error handler
      console.error('Failed to get file URL:', error.message);
    }
    if (props.onFileUploaded) props.onFileUploaded()
  }

  const handleInputChange = (newValue) => {
    if (props.onChange) props.onChange(props.name, newValue)
  }

  const connectedRight = <div>
    <input
      type='file'
      onChange={(e) => handleFileChange(e)}
      ref={inputFileRef}
      className='hidden'
    />
    <Button onClick={handleButtonClick} disabled={props.loading}>
      {props.loading ? 'Uploading...' : 'Upload an image'}
    </Button>
  </div>

  return (
    <TextField
      {...props}
      placeholder='Image url'
      onChange={handleInputChange}
      connectedRight={connectedRight}
    />
  )
}

export default FileInputComponent
